import { createContext } from 'react'
import type { TActivitySummaryContext } from './typings'

export const ActivitySummaryContext = createContext<
  TActivitySummaryContext | undefined
>(undefined)
